import { css } from "@emotion/react";
import styled from "@emotion/styled";

type ContainerProps = {
  $isShowPaywall?: boolean;
};

export const LoadingContainer = styled.div`
  position: absolute;

  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;

  inline-size: 100%;
  block-size: 100%;
`;

export const Container = styled.div<ContainerProps>`
  position: relative;

  display: none;

  ${props =>
    props.$isShowPaywall === true &&
    css`
      display: flex;

      ${LoadingContainer} {
        display: none;
      }
    `}

  min-block-size: 530px;
`;

export const Wrapper = styled.div`
  position: absolute;

  inline-size: 100%;
  block-size: 100%;
`;
